import { useTournamentPrizes } from '@hooks/queries/useTournaments'
import { REWARD_TYPE } from '@constants/tournamentConstants'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import PrizeRow from './PrizeRow'

// Prize table for one tournament — a single, unpaginated fetch (the query
// takes no page/size params; it's a short fixed list of positions). Own
// header + rows (not the generic TournamentsList shell, which has no header
// concept) — ports defenderV2's _tournamentsPrizes.scss structure exactly.
const TournamentPrizesTab = ({ tournamentId, rewardType }) => {
  const { data, isPending, isError } = useTournamentPrizes({ tournamentId })
  const rows = data?.rows ?? []
  const rewardHeaderLabel = rewardType === REWARD_TYPE.FREEBET ? 'Freebets' : 'Amount'

  if (isPending) {
    return (
      <div className="standard-normal-tournament-prizes-outer-container">
        <div className="standard-normal-tournament-prizes-loading-container">
          <SpinningLoader />
        </div>
      </div>
    )
  }

  if (isError || !rows.length) {
    return (
      <div className="standard-normal-tournament-prizes-outer-container">
        <div className="standard-normal-tournament-prizes-empty-container">
          {isError ? 'Ooops! Something Went Wrong!' : 'No Prizes Found for this Tournament'}
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-tournament-prizes-outer-container">
      <div className="standard-normal-tournament-prizes-inner-container">
        <div className="standard-normal-tournament-prizes-header-row">
          <div className="standard-normal-tournament-prizes-header-element">Position</div>
          <div className="standard-normal-tournament-prizes-header-element">{rewardHeaderLabel}</div>
        </div>
        <div className="standard-normal-tournament-prizes-body no-scrollbar">
          {rows.map((row, index) => (
            <PrizeRow key={row.position ?? index} data={row} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TournamentPrizesTab
